<template>
  <div class="userinfo-div">
    <el-descriptions title="平台信息" :column="1" size="medium" :style="{width:'600px',height: height}" border labelClassName="detail-label" contentClassName="detail-content">
      <el-descriptions-item>
        <template slot="label"><i class="el-icon-user-solid"></i>登录账号</template>
        {{userInfo.username}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"><i class="el-icon-tickets"></i>名称</template>
        {{platInfo.userName}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"><i class="el-icon-open"></i>状态</template>
        {{platInfo.status|dict(dictStatus)}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"><i class="el-icon-time"></i>增加时间</template>
        {{platInfo.createTime}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"><i class="el-icon-tickets"></i>备注</template>
        {{platInfo.remark}}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'userplatUserUserinfo',
  data () {
    return {
      height: window.innerHeight - 200 + 'px',
      platInfo: {},
      dictStatus: [], // 状态
      dictCheckStatus: [] // 审核状态
    }
  },
  mounted () {
    this.getPlatInfo()
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
  },
  methods: {
    getPlatInfo () {
      axios({
        url: this.baseUrl + '/user/userInfo',
        method: 'get'
      }).then(res => {
        this.platInfo = res.data.data || {}
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.userinfo-div {
  margin: 10px;
  padding: 30px;
  background-color: #fff;
}
.detail-label i {
  margin-right: 4px;
}
.detail-label {
  width: 140px;
}
</style>
